import { observable } from "mobx";

export default class Collection<T> {
    @observable values: T[] = [];
}